import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SearchFilters } from "@/models/searchFilters";
import { ProjectSearchOutput } from "@/models/project";

// Define state type
interface ExploreState {
  searchResults: any;
  searchTerm: string | null;
  filters: SearchFilters;
  searchOutputs: ProjectSearchOutput[] | null;
  page: number;
  limit: number;
  totalCount: number;
  totalPages: number;
}

// Initial state
const initialState: ExploreState = {
  searchTerm: null,
  filters: { country: "", listOfTags: [], projectOrCharity: "" },
  searchOutputs: null, // Now matches backend naming
  page: 1,
  limit: 2, // Default limit per page
  totalCount: 0,
  totalPages: 1,
  searchResults: undefined,
};

export const exploreSlice = createSlice({
  name: "explore",
  initialState,
  reducers: {
    setSearchTerm: (state, action: PayloadAction<string>) => {
      state.searchTerm = action.payload;
      state.page = 1; // Reset pagination
    },
    setFilters: (state, action: PayloadAction<SearchFilters>) => {
      state.filters = action.payload;
      state.page = 1; // Reset pagination
    },
    deleteFilterTag: (state, action: PayloadAction<string>) => {
      state.filters.listOfTags = state.filters.listOfTags.filter(
        (tag) => tag !== action.payload,
      );
      state.page = 1; // Reset pagination
    },
    clearFilterCountry: (state) => {
      state.filters.country = "";
      state.page = 1; // Reset pagination
    },
    setSearchOutputs: (
      state,
      action: PayloadAction<{
        searchOutputs: ProjectSearchOutput[];
        page: number;
        limit: number;
        totalCount: number;
        totalPages: number;
      }>,
    ) => {
      state.searchOutputs = action.payload.searchOutputs;
      state.page = action.payload.page;
      state.limit = action.payload.limit;
      state.totalCount = action.payload.totalCount;
      state.totalPages = action.payload.totalPages;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setLimit: (state, action: PayloadAction<number>) => {
      state.limit = action.payload;
      state.page = 1; // Reset to first page when limit changes
    },
  },
});

// Export actions & reducer
export const {
  setSearchTerm,
  setFilters,
  deleteFilterTag,
  clearFilterCountry,
  setSearchOutputs, // Updated function name
  setPage,
  setLimit,
} = exploreSlice.actions;

export default exploreSlice.reducer;
